<template>
    <v-container v-if="country" class="industryPerformanceScore">
        <v-row>
            <template v-if="comparisonMode">
                <v-col cols="12" class="pl-3 mt-3">
                    <v-row no-gutters>
                        <v-col v-for="(entry) in paginatedData" :key="entry.name" cols="6" class="pa-0">
                            <v-row no-gutters>
                                <v-col :class="entry.name.toLowerCase()" class="pa-0">
                                    <v-img :src="require('@/assets/icons/industry/' + entry.name.toLocaleLowerCase() + '.svg')" :class="'industryIcon ' + entry.name.toLocaleLowerCase()" />
                                </v-col>
                            </v-row>
                             <v-row no-gutters>
                                <span class="scoreName">{{ entry.name }} <v-icon v-tooltip="entry.tooltip" class="rating-tooltip">mdi-information-outline</v-icon></span>
                            </v-row>
                            <v-row class="infoRow">
                                <v-col>
                                    <v-row v-for="industry in entry.industries" :key="industry.name" class="pa-0">
                                        <v-col cols="1" class="pa-0">
                                            <v-img :src="require('@/assets/icons/tick.svg')" class="tickIcon" />
                                        </v-col>
                                        <v-col cols="10" class="pa-0">
                                            <span class="industryName">{{ industry.name }}</span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </template>
            <template v-else>
                <template v-if="isMobile">
                    <v-col v-for="(entry) in paginatedData" :key="entry.name" md="2">
                        <v-row>
                            <v-col class="pa-0">
                                <v-img :src="require('@/assets/icons/industry/' + entry.name.toLocaleLowerCase() + '.svg')" :class="'industryIcon ' + entry.name.toLocaleLowerCase()" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <span class="scoreName">
                                {{ entry.name }} 
                                <!-- <v-icon 
                                open-on-click 
                                v-tooltip="entry.tooltip" 
                                class="rating-tooltip">
                                    mdi-information-outline
                                </v-icon> -->
                                <v-tooltip open-on-click width="90%" class="rating-tooltip" v-if="isMobile">
                                    <template v-slot:activator="{ props }">
                                        <!-- <v-icon v-bind="props" class="lineItem movementInfoIcon">mdi-information-outline</v-icon> -->
                                        <v-img v-bind="props" :src="require('@/assets/icons/atradius-info.svg')" class="info-icon" />
                                    </template>
                                    <span>{{entry.tooltip}}</span>
                                </v-tooltip>
                            </span>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-row v-for="industry in entry.industries" :key="industry.name" class="pa-0">
                                    <v-col cols="1" class="pa-0">
                                        <v-img :src="require('@/assets/icons/tick.svg')" class="tickIcon" />
                                    </v-col>
                                    <v-col cols="10" class="pa-0">
                                        <span class="industryName">{{ industry.name }}</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </template>
                <template v-else>
                    <v-col v-for="(entry) in organizedData" :key="entry.name">
                        <v-row>
                            <v-col class="pa-0">
                                <v-img :src="require('@/assets/icons/industry/' + entry.name.toLocaleLowerCase() + '.svg')" :class="'industryIcon ' + entry.name.toLocaleLowerCase()" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <span class="scoreName">{{ entry.name }} <v-icon v-tooltip="entry.tooltip" class="rating-tooltip">mdi-information-outline</v-icon></span>                          
                            
                        </v-row>
                        <v-row class="infoRow">
                            <v-col>
                                <v-row v-for="industry in entry.industries" :key="industry.name" class="pa-0 ">
                                    <v-col cols="1" class="pa-0">
                                        <v-img :src="require('@/assets/icons/tick.svg')" class="tickIcon" />
                                    </v-col>
                                    <v-col cols="10" class="pa-0">
                                        <span class="industryName">{{ industry.name }}</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </template>
            </template>
        </v-row>
        <div class="mobile-pagination-bg" v-if="pageCount > 1 && (comparisonMode && isMobile && !duplicate && !singleCompare)"></div>
            
		<v-pagination
			v-if="pageCount > 1 && (comparisonMode || isMobile)"
			:value="sharedPage"
			@update:modelValue="pageChanged($event)"
			:length="pageCount"
			:key="pageCount"
			:class="paginationClasses()"
			density="compact"
			variant="text"
		>
			<template v-slot:item>
				<div class="paginationItem"></div>
			</template>
		</v-pagination>

    </v-container>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, onBeforeUnmount, watch } from 'vue';
import store from '@/store';

// const toolTipData = store.getters['displayStoreData/toolTipData'];

let scoreMap = [
    { score: "5", name: 'Excellent', tooltip: 'The credit risk situation in the sector is strong/business performance in the sector is strong compared to its long-term trend.' },
    { score: "4", name: 'Good', tooltip: 'The credit risk situation in the sector is benign/business performance in the sector is above its long-term trend.' },
    { score: "3", name: 'Fair', tooltip: 'The credit risk credit situation in the sector is average/business performance in the sector is stable.' },
    { score: "2", name: 'Poor', tooltip: 'The credit risk situation in the sector is relatively high/business performance in the sector is below long-term trend.' },
    { score: "1", name: 'Bleak', tooltip: 'The credit risk situation in the sector is poor/business performance in the sector is weak compared to its long-term trend.' }
];




const nameMap = [
    { system_name: "agriculture", name: 'Agriculture' },
    { system_name: "automotive", name: 'Automotive' },
    { system_name: "chemicals", name: 'Chemicals' },
    { system_name: "construction_const_mtrls", name: 'Construction & Materials' },
    { system_name: "consumer_durables", name: 'Consumer Durables' },
    { system_name: "electronics_ict", name: 'Electronics & ICT' },
    { system_name: "financial_services", name: 'Financial Services' },
    { system_name: "food", name: 'Food' },
    { system_name: "machines_engineering", name: 'Machines & Engineering' },
    { system_name: "metals_steel", name: 'Metals & Steel' },
    { system_name: "paper", name: 'Paper' },
    { system_name: "pharmaceuticals", name: 'Pharmaceuticals' },
    { system_name: "services", name: 'Services' },
    { system_name: "textiles", name: 'Textiles' },
    { system_name: "transport", name: 'Transport' }
];

interface Entry {
    name: string;
    score: string;
    tooltip: string;
    industries: { name: string }[];
}

export default defineComponent({
    props: {
        country: {
            type: Object,
            required: true,
        },
        comparisonMode: {
            type: Boolean,
            required: false,
        },
        sharedPage: {
            type: Number,
            required: true,
        },
        duplicate: {
            type: Boolean,
            required: false,
        },
        singleCompare: {
            type: Boolean,
            required: false,
        }
    },
    name: 'IndustryPerformanceScores',
    data() {
        return {
            scoreMap,
            nameMap,
            organizedData: [] as Entry[],
            itemsPerPage: 2, // Adjust this to the number of items you want per page
            isMobile: false
        };
    },
    computed: {
        paginatedData(): Entry[] {
            const start = (this.sharedPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.organizedData.slice(start, end);
        },
        pageCount(): number {
            return Math.ceil(this.organizedData.length / this.itemsPerPage);
        }
    },
    methods: {
        updateScoreMap() {
            const toolTipData = store.getters['displayStoreData/toolTipData'];
            console.log('UPDATED SCORE ',toolTipData);
            if(toolTipData) {
                
                scoreMap = [
                { score: "5", name: 'Excellent', tooltip: toolTipData.industry_performance_scores.excellent.text || 'Excellent' },
                { score: "4", name: 'Good', tooltip:  toolTipData.industry_performance_scores.good.text || 'Good' },
                { score: "3", name: 'Fair', tooltip:  toolTipData.industry_performance_scores.fair.text || 'Fair' },
                { score: "2", name: 'Poor', tooltip:  toolTipData.industry_performance_scores.poor.text || 'Poor' },
                { score: "1", name: 'Bleak', tooltip:  toolTipData.industry_performance_scores.bleak.text || 'Bleak' }
                
            ];
            console.log('UPDATED SCORE 1',scoreMap);
        }
        },
        formatScoreData() {
            const entries: any = [];
            scoreMap.forEach(scoreItem => {
                entries.push({
                    name: scoreItem.name,
                    score: scoreItem.score,
                    tooltip: scoreItem.tooltip,
                    industries: []
                });
            });

            for (const key in this.country.industryPerformance[0]) {
                if (key != 'name' && key != 'iso') {
                    const countryIndustryScore = this.country.industryPerformance[0][key];
                    for (let entryIndex = 0; entryIndex < entries.length; entryIndex++) {
                        const entry = entries[entryIndex];
                        if (entry.score == countryIndustryScore) {
                            entry.industries.push({
                                name: nameMap.find(item => item.system_name == key)?.name,
                            });
                        }
                    }
                }
            }

            this.organizedData = entries;
            
        },
        checkIfMobile() {
            this.isMobile = window.innerWidth <= 900;
        },
        pageChanged(event: any) {
            this.$emit('page-changed', event);
        },
        paginationClasses() { 
            
            var paginationClass = 'mt-4 pagination-styles ';
            if (this.duplicate) {
                paginationClass = 'hide-pagination';
            } else if (this.comparisonMode && this.singleCompare && !this.isMobile) {
                paginationClass +=  'custom-single-compare-desktop custom-pagination';
            } else if (this.comparisonMode && !this.isMobile) {
                paginationClass +=  'custom-double-compare-desktop custom-pagination';
            } else if (this.comparisonMode && !this.singleCompare && this.isMobile) {
                paginationClass +=  'custom-double-compare-mobile custom-pagination';
            } else if (this.comparisonMode && !this.singleCompare) {
                paginationClass +=  'custom-pagination-compare custom-pagination';
            } else {
                paginationClass +=  'custom-pagination';
            }
            return paginationClass;
        }
    },
    watch: {
        country() {
            this.formatScoreData();
            this.updateScoreMap();
        },
        singleCompare() {
            // 
        }
    },
    mounted() {
        this.updateScoreMap();
        this.formatScoreData();
        this.checkIfMobile();
        window.addEventListener('resize', this.checkIfMobile);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.checkIfMobile);
    }
});
</script>

<style scoped>
.industryIcon {
    width: 20px;
    height: 20px;
}

.scoreName {
    font-family: 'GCO', sans-serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 60px;
    letter-spacing: -2%;
    text-align: left;
}

.industryName {
    font-family: 'GCO sans', sans-serif;
    text-align: left;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    display: block;
    margin-bottom: 10px;
    padding-left: 7px;
}

.tickIcon {
    margin-top: 3px;
    width: 20px;
    height: 20px;
}

.infoRow {
    margin-bottom: 20px;
    overflow-y: auto;

	@media (max-height: 600px)
	{
    	height: 120px;
	}
}

/* Style the scrollbar for Chrome, Edge, and Safari */
.infoRow::-webkit-scrollbar {
    width: 5px; /* Width of the scrollbar */
}

.infoRow::-webkit-scrollbar-track {
    background: #f1f1f1; /* Color of the track */
}

.infoRow::-webkit-scrollbar-thumb {
    background: #888; /* Color of the scrollbar thumb */
}

.infoRow::-webkit-scrollbar-thumb:hover {
    background: #555; /* Color of the scrollbar thumb on hover */
}

/* Style the scrollbar for Firefox */
.infoRow
{
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
}

.v-pagination__item--is-active .paginationItem
{
    background-color: #DC0128 !important;
}


.paginationItem
{
    width: 50px;
    height: 1.5px;
    background-color: #a9a9a9;
    margin: 0 5px;
    position:relative;
    top: 50%;
    transform: translateY(-50%); 
	left: -40px;

	@media (max-width: 283px)
	{
		left: 0px;
	}
	
}

.custom-pagination,
.custom-pagination-compare
{
    position: absolute;
    bottom: 130px;
    left: 50%;
    transform: translateX(-50%);
}

.custom-double-compare-mobile
{
    /* position: absolute; */
    /* bottom: 110px; */
    margin-bottom: 70px;
}

.custom-pagination
{
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);

	@media (max-width: 900px)
	{
		position: static;
		left: 0%;
		transform: translateX(-0%);
	}
	
	.paginationItem
	{
		width: 300px;

		@media (max-width: 1200px)
		{
			width: 235px;
		}
		@media (max-width: 900px)
		{
			width: 120px;
		}
		@media (max-width: 600px)
		{
			width: 60px;
		}
		@media (max-width: 400px)
		{
			width: 50px;
		}

	}
}




.hide-pagination
{
    display: none;
}


.rating-tooltip
{
    font-size: 20px;
    font-weight: 100;
    font-family: 'GCO Sans', sans-serif;

}
</style>

<style>

.industryPerformanceScore
{
	clear: both;
	overflow: scroll;
}

.custom-pagination,
.custom-pagination .v-pagination__next
{
	.v-pagination__prev,
	.v-pagination__next
	{
		position: absolute;
		right: 0;
		top: -3px;
	}

	.v-pagination__prev
	{
		right: -40px;
	}
	.v-pagination__next
	{
		right: -90px;
	}


	@media (max-width: 900px)
	{
		.v-pagination__prev
		{
			right: 40px;
		}
		.v-pagination__next
		{
			right: 0px;
		}
	}


	@media (max-width: 600px)
	{
		.v-pagination__prev
		{
			right: 0px;
		}
		.v-pagination__next
		{
			right: -30px;
		}
	}


	@media (max-width: 283px)
	{
		position: static;
	}
}





.pagination-styles .v-btn:hover span.v-btn__overlay{
    background: none;
}

.pagination-styles > * {
    color: #333333;
}

</style>
